export default __webpack_public_path__ + "static/media/stabilizer.cfcb567d.svg";